import { useContext, useEffect, useState } from "react";
import { UserContext } from "./UserContext";
import useEventoStore from "../../stores/useEventoStore";

const rolPermitido = (data, allowedRoles) => {
  const rol = data?.eventoUsuario?.idrol;
  return rol !== undefined && rol !== null && allowedRoles.includes(Number(rol));
};

// con el evento ya en el store se resuelve en el primer render, sin loading
const useAccesoEvento = (id, allowedRoles) => {
  const { setUserRole } = useContext(UserContext);
  const enCache = useEventoStore.getState().getEvento(id);
  const [estado, setEstado] = useState(() =>
    enCache
      ? { cargando: false, permitido: rolPermitido(enCache, allowedRoles) }
      : { cargando: true, permitido: false }
  );

  // App.js pasa los roles como array literal (nuevo en cada render)
  const roles = allowedRoles.join(",");

  useEffect(() => {
    let vigente = true;
    const permitidos = roles.split(",").map(Number);
    useEventoStore.getState().fetchEvento(id)
      .then((data) => {
        const rol = data?.eventoUsuario?.idrol;
        if (rol !== undefined && rol !== null) setUserRole(rol);
        if (vigente) setEstado({ cargando: false, permitido: rolPermitido(data, permitidos) });
      })
      .catch((error) => {
        console.error("Error fetching user role: ", error);
        if (vigente) setEstado({ cargando: false, permitido: false });
      });
    return () => { vigente = false; };
  }, [id, roles, setUserRole]);

  return estado;
};

export default useAccesoEvento;
